import { render } from "./SwiftPlusStatement.vue?vue&type=template&id=0b6de28c&scoped=true"
import script from "./SwiftPlusStatement.vue?vue&type=script&lang=js"
export * from "./SwiftPlusStatement.vue?vue&type=script&lang=js"

import "./SwiftPlusStatement.vue?vue&type=style&index=0&id=0b6de28c&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6de28c"]])

export default __exports__